import { useAppSystem } from "@/global/hooks/useAppSystem";
import {
  convertDate,
  convertShortDate,
  convertTime,
} from "@/global/utils/dateTimeConvert";
import Image from "next/image";
import {
  Box,
  Chip,
  Divider,
  Stack,
  Theme,
  Typography,
  lighten,
} from "@mui/material";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";

interface Props {
  logoUrl: string;
  title: string;
  date: string;
  time: string;
  tag: string;
  isSelected?: boolean;
  onClick?: (a: any) => void;
}

export function PackageEvent(props: Props) {
  const { theme } = useAppSystem();
  const styles = useStyles(theme, props);
  const { sm: smDown } = useCssMediaQuery("down");

  return (
    <Box sx={styles.root} p={1} onClick={props.onClick}>
      <Stack
        direction={"row"}
        justifyContent={"flex-start"}
        alignItems={"center"}
        spacing={1}
      >
        <Box>
          {props.logoUrl ? (
            <Image
              src={props.logoUrl}
              alt={"team logo"}
              width={48}
              height={48}
            />
          ) : null}
        </Box>

        <Box textAlign={"left"}>
          <Box>
            <Typography fontSize={"1rem"} fontWeight={700}>
              {props.title}
            </Typography>
          </Box>
          <Box display={"flex"} alignItems={"center"} gap={"0.5rem"}>
            <Typography
              variant="body1"
              color="text.secondary"
              fontSize={"0.9rem"}
              fontWeight={"500"}
            >
              {smDown ? convertShortDate(props.date) : convertDate(props.date)}
            </Typography>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Typography
              variant="body1"
              color="text.secondary"
              fontSize={"0.9rem"}
              fontWeight={"500"}
            >
              {convertTime(props.time)}
            </Typography>
          </Box>
        </Box>
      </Stack>

      <Stack
        sx={styles.tagWrapper}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        width="100%"
        spacing={1}
      >
        <Box pr={2}>
          {props.tag ? (
            <Chip
              color={"primary"}
              label={
                <Typography fontSize={"12px"} fontWeight={500}>
                  {props.tag}
                </Typography>
              }
              variant={"filled"}
              size={"small"}
            />
          ) : null}
        </Box>
      </Stack>
    </Box>
  );
}

function useStyles(theme: Theme, states: Props) {
  // colors
  const primaryColor = theme.palette.primary.main;
  const dividerColor = theme.palette.divider;
  const hoverShadowColor = lighten(theme.palette.primary.main, 0.8);

  // styles
  const borderSize = states?.isSelected ? "2px" : "1px";
  const borderColor = states?.isSelected ? primaryColor : dividerColor;

  return {
    root: {
      position: "relative",
      outline: `${borderSize} solid ${borderColor}`,
      borderRadius: "6px",
      transition: "all 0.2s ease-in-out",

      // "&:hover": {
      //   boxShadow: `0 0 0 6px ${hoverShadowColor}`,
      // },
    },

    tagWrapper: {
      position: "absolute",
      width: "fit-content",
      top: 0,
      right: 0,
      zIndex: 1,
      transform: "translateY(-50%)",
    },
  };
}
